import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import AuthUser from "../../Hooks/authUser";

const AdminDashboardNav = () => {
  const { userInfo, logout } = AuthUser();
  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await fetch(
          `https://servercareseebd.careseebd.com/api/v1/user/specific?fieldName=role&&fieldValue=doctor&&fieldName2=referralId&&fieldValue2=${userInfo?._id}`,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("careSeeAccessToken")}`,
            },
          }
        );
        const data = await response.json();
        setDoctors(data?.data || []);
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    };

    if (userInfo?._id) {
      fetchDoctors();
    }
  }, [userInfo?._id]);

  const activeStyle = "flex items-center gap-3 bg-secondary text-white py-2.5 px-4 rounded-xl shadow-md shadow-indigo-950/20 font-bold text-sm transition-all duration-200";
  const inactiveStyle = "flex items-center gap-3 text-slate-500 hover:text-secondary hover:bg-slate-50 py-2.5 px-4 rounded-xl font-semibold text-sm transition-all duration-200";

  return (
    <div className="w-full bg-white rounded-2xl border border-slate-100 p-5 shadow-sm space-y-6 flex flex-col h-full">
      {/* Admin Profile Details */}
      <div className="flex items-center gap-3 border-b border-slate-100 pb-5">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-tr from-secondary to-indigo-500 flex items-center justify-center text-white font-black text-base shadow-sm uppercase">
          {userInfo?.name ? userInfo.name.charAt(0) : "A"}
        </div>
        <div className="min-w-0">
          <p className="text-sm font-black text-slate-800 tracking-tight truncate">
            {userInfo?.name || "Administrator"}
          </p>
          <span className="inline-block text-[9px] font-bold text-secondary bg-indigo-50 px-2 py-0.5 rounded-full mt-0.5 uppercase tracking-wide">
            SYSTEM ADMIN
          </span>
        </div>
      </div>

      {/* Nav Menu */}
      <nav className="flex-1 space-y-1.5">
        <NavLink
          to="overview"
          className={({ isActive }) => (isActive ? activeStyle : inactiveStyle)}
        >
          <Icon icon="solar:widget-bold-duotone" className="text-lg" />
          <span>Dashboard</span>
        </NavLink>
        <NavLink
          to="doctors"
          className={({ isActive }) => (isActive ? activeStyle : inactiveStyle)}
        >
          <Icon icon="solar:user-speak-bold-duotone" className="text-lg" />
          <span>Doctors List</span>
        </NavLink>
        <NavLink
          to="editProfile"
          className={({ isActive }) => (isActive ? activeStyle : inactiveStyle)}
        >
          <Icon icon="solar:user-id-bold-duotone" className="text-lg" />
          <span>Edit Profile</span>
        </NavLink>
        <NavLink
          to="changePassword"
          className={({ isActive }) => (isActive ? activeStyle : inactiveStyle)}
        >
          <Icon icon="solar:key-bold-duotone" className="text-lg" />
          <span>Security</span>
        </NavLink>
      </nav>

      {/* Stats Counter card */}
      <div className="bg-gradient-to-br from-indigo-50 to-cyan-50/50 p-4 rounded-xl border border-indigo-100/50">
        <div className="flex items-center gap-3">
          <div className="p-2.5 bg-white text-secondary rounded-lg shadow-sm">
            <Icon icon="solar:users-group-two-rounded-bold-duotone" className="text-lg" />
          </div>
          <div>
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wide">Total Doctors</p>
            <p className="text-lg font-black text-slate-800 mt-0.5 leading-none">{doctors?.length || 0}</p>
          </div>
        </div>
      </div>

      {/* Logout button */}
      <button
        onClick={logout}
        className="w-full flex items-center gap-3 text-red-500 hover:text-red-650 hover:bg-red-50 py-2.5 px-4 rounded-xl font-bold text-sm transition-all duration-150 border border-transparent hover:border-red-100"
      >
        <Icon icon="solar:logout-bold-duotone" className="text-lg" />
        <span>Logout</span>
      </button>
    </div>
  );
};

export default AdminDashboardNav;
